import React from 'react';
import MapComponent from '../../components/Map';
import './Map.css';

export default function Map(props) {
  let {poi} = props;
  let info = poi.info;

  let marker = {
    type: 'locateMarker',
    className: 'locate',
    size: {
      width: '0.8rem',
      height: '0.8rem'
    },
    latLng:[info.lat, info.lng]
  };

  return (
    <div className='map-wrap'>
      <MapComponent markers={[marker]} maxZoom={13} />
      <div className='map-mask' onClick={props.onClick}></div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/poi2/Map.js